import Typography      from '@mui/material/Typography'
import Paper           from '@mui/material/Paper'
import Button          from '@mui/material/Button'

import Box             from '@mui/material/Box'
import Modal           from 'Components/Modal'
import { usePatient }  from 'Components/usePatientContext'
import api             from "lib/api_clinica"
import { useFallBack } from 'Components/useFallBack'
import { toast } from 'react-toastify'

const style = {
    py: 4,
    bgcolor: 'background.default',
    display: 'grid',
    gridTemplateColumns: { md: '1fr 1fr', xs: '1fr 1fr' },
    gap: 2,
}

const defaultProps = {
    elevation: 4,
    component: Paper,
    sx: { minHeight: '80px', color: '#000', fontWeight: 'bold' }
}

export const ButtonsParticularConvenio = () => {

    const { patient, setPatient, setRedirect, setLoading } = usePatient()

    const { isOpen, setOpen, modal, setModal } = useFallBack()


    const handleClose = () => {
        setOpen(false)  
    }

    const handleConfirm = () => {
        setOpen(false)
    }

    const getPageByConvenio = async (params) => {

        try {

            setLoading(true) 
            
            const response = await api.page.convenio.post(params)
            
            const { redirect, state } = response

            setPatient( 
                prevState => (
                { 
                    ...prevState, 
                        idConvenio       : state.idConvenio,
                        descricaoConvenio: state.descricaoConvenio,
                        idPlano          : state.idPlano
                }
            ))
            
            if (response?.modal !== undefined) {
                setModal({...response?.modal, redirect, handleClose, handleConfirm }) 
                setOpen(true)     
            } else {
                setRedirect(redirect)
            }

        } catch (error) {
            console.log(error, 'error')
            toast.error('Não foi possível prosseguir com o agendamento, problema no servidor.')    
              
        } finally {
            setLoading(false)
        }

    }

    const getPageByParticular = async (params) => {

        try {

            setLoading(true) 
            
            const response = await api.page.particular.post(params)
            
            const { redirect, state } = response

            setPatient( 
                prevState => (
                { 
                    ...prevState, 
                        idPlano          : state.idPlano,
                        idConvenio       : state.idConvenio,
                        descricaoConvenio: state.descricaoConvenio,
                        
                }
            ))
            
            if (response?.modal !== undefined) {
                setModal({...response?.modal, redirect, handleClose, handleConfirm }) 
                setOpen(true)     
            } else {
                setRedirect(redirect)
            }

        } catch (error) {
            console.log(error, 'error')
            toast.error('Não foi possível prosseguir com o agendamento, problema no servidor.')    
              
        } finally {
            setLoading(false)
        }

    }

    const handleParticular = () => {
        const params = { cpfPaciente: patient.cpfPaciente }
        getPageByParticular(params)
    }
    
    const handleConvenio = () => {   
        const params = { cpfPaciente: patient.cpfPaciente }
        getPageByConvenio(params)
    }

    return <>
        <Modal 
            open={isOpen} 
            {...modal}
            disableEscapeKeyDown
            hideImportant={true}
        />
        <Box sx={style} >
            <Button 
                id='particular'
                name='particular'
                onClick={ _ => handleParticular() }
                {...defaultProps} 
            >
                <Typography component={'p'}>Particular</Typography>
            </Button>
            <Button 
                id='convenio'
                name='convenio'
                onClick={ _ => handleConvenio() }
                {...defaultProps} 
            >
                <Typography component={'p'}>Convênio</Typography>
            </Button>
        </Box>
    </>
}

